import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ExportThemeEdition = _resolveComponent("ExportThemeEdition")!
  const _component_RuleTable = _resolveComponent("RuleTable")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                cols: "12",
                class: "my-3 justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_primary, {
                        block: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'export-theme-edition-new' })))
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode(" Ajouter ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "8",
                    class: "pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.search,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                        "append-inner-icon": "$search",
                        clearable: "",
                        "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = '')),
                        label: "Recherche",
                        outlined: "",
                        "hide-details": "",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_combobox, {
                        modelValue: _ctx.filterCompany,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterCompany) = $event)),
                        items: _ctx.allAvailableCompanies,
                        label: "Société",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_RuleTable, {
            rule: 'exportTheme',
            items: _ctx.sortedThemes,
            hideDuplication: true,
            hideIntersection: true,
            accountingCompanyId: _ctx.accountingCompanyId,
            toExpandId: _ctx.themeSelectedId,
            showPreview: _ctx.show,
            maxHeight: _ctx.maxHeightRT,
            onToRoute: _cache[4] || (_cache[4] = ($event: any) => (_ctx.routeEdition($event.id))),
            onIconClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPreview($event.id))),
            onDuplicate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.duplicateTheme($event.id))),
            onDelete: _cache[7] || (_cache[7] = ($event: any) => {
                    _ctx.exportThemeToDelete = $event;
                    _ctx.deleteDialog = true;
                })
          }, {
            default: _withCtx(({ previewItem }) => [
              _createVNode(_component_ExportThemeEdition, {
                themeSettingsFromProp: previewItem.theme,
                previewMode: true
              }, null, 8, ["themeSettingsFromProp"])
            ]),
            _: 1
          }, 8, ["items", "accountingCompanyId", "toExpandId", "showPreview", "maxHeight"])
        ]),
        _: 1
      }),
      (_ctx.deleteDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.deleteDialog,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.deleteDialog) = $event)),
            title: "Supprimer",
            error: true,
            onValid: _ctx.deleteTheme,
            width: "800px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h4", _hoisted_1, _toDisplayString("Êtes-vous sûr(e) de vouloir supprimer " + _ctx.exportThemeToDelete.name + " ?"), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "onValid"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}